// Billed first when ascending; teams without isBillable sort after both.
const toSortable = (value, sortBy) => {
  if (sortBy === "isBillable")
    return value == null ? 2 : Number(!value);
  return value ?? "";
};

export const sortTeams = (teams, sortBy, reverse) =>
  [...teams].sort((a, b) => {
    const aValue = toSortable(a[sortBy], sortBy);
    const bValue = toSortable(b[sortBy], sortBy);

    if (typeof aValue === "number" || typeof bValue === "number") {
      return reverse ? bValue - aValue : aValue - bValue;
    }
    return reverse
      ? bValue.localeCompare(aValue)
      : aValue.localeCompare(bValue);
  });
